

export enum CandidateStatusEnum {
  Paid = 1,
  Complete = 2,
  Admitted = 3,
  Applicant = 4,
  NotAdmitted = 5,
  Hired = 6,
  Discharged = 7,
  OfferedAdmission = 8,
  Lead = 9,
  Enrolled = 10,
  Disqualified = 11,
  Dropped = 12
}
    

